import {
  LIVE_TOUR_OPERATOR_LIST_START,
  LIVE_TOUR_OPERATOR_LIST_SUCCESS,
  LIVE_TOUR_OPERATOR_LIST_ERROR,
  TOUR_PRIORITY_DATA_START,
  TOUR_PRIORITY_DATA_SUCCESS,
  TOUR_PRIORITY_DATA_ERROR,
} from "../Constants/LiveTourOperatorListConstant";
const initialState = {
  loading: false,
  liveTourOperatorListData: {},
  priorityAddData: {},
};
export default function LiveTourOperatorListReducers(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case LIVE_TOUR_OPERATOR_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case LIVE_TOUR_OPERATOR_LIST_SUCCESS:
      return {
        ...state,
        liveTourOperatorListData: action.payload,
        loading: false,
      };
    case LIVE_TOUR_OPERATOR_LIST_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case TOUR_PRIORITY_DATA_START:
      return {
        ...state,
        loading: true,
      };
    case TOUR_PRIORITY_DATA_SUCCESS:
      return {
        ...state,
        priorityAddData: action.payload,
        loading: false,
      };
    case TOUR_PRIORITY_DATA_ERROR:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
